module.exports = __webpack_public_path__ + "img/dsci0008.6fbbed84.jpg";